module.exports = __webpack_public_path__ + "img/borderIcon.e7303bbd.svg";